import React from "react";
import "./Banner.css";
function Banner() {
  return <div className="banner-container" />;
}

export default Banner;
